import { Navigate, Outlet, RouteObject } from "react-router-dom";
import moduleRoutes from "./moduleRouteList";
import insuranceRoute from "../Insurance";
import authenticationRoute from "../Authentication";
import AuthenticationStatus from "../Authentication/component/AuthenticationStatus";
import mainDashboardRoutes from "../MainDashboard";
import patientCareRoutes from "../PatientCare";
import reportsRoutes from "../Reports";
import PageNotFound from "../ErrorPages/PageNotFound";
import ErrorBoundary, { ErrorPage } from "../ErrorPages/ErrorBoundary";
import mastersRoutes from "../Masters";
import { SettingsRoutes } from "../Settings";
import MainLayoutContainer from "../layout/MainLayoutContainer";
import helpRoute from "../Help/index";
import TokenExpiredPage from "../ErrorPages/TokenExpiredPage";
import PageRouterList from "./routeList";
import Loader from "@utilifiles/component/SkeletonLoading/Loader";
import UnauthorizedAccessPage from "../ErrorPages/UnAuthorizedPage";
import useAuthentication from "@hooks/useAuthentication";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import GoogleOAuthCallback from "../Masters/GoogleForms/GoogleOAuthCallback";
import DoctorWaitingQueue from "../PatientCare/PatientBooking/v2/DoctorWaitingQueue";
import PatientFeedbackPage from "../PatientFeedback/PatientFeedbackPage";

const base = (window as any)._env_?.BASE_URL || "/";
const resetFunction = () => {
  location.reload();
};

 function RootRedirect() {
  const { isAuthenticated, isLoading } = useAuthentication();

  if (isLoading) return null; // show loader if you want

  if (isAuthenticated) return <Navigate to={moduleRoutes.mainRoute} replace />;
  
  return <Navigate to={moduleRoutes.authentication} replace />; 
}

const globalRouteObjectList: RouteObject[] = [
  {
    path: base,
    element: (
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    ),
    errorElement: <ErrorPage resetError={resetFunction} />,
    children: [
      { index: true, element: <RootRedirect />, },
      { ...authenticationRoute }, // login / auth routes

      // Protected /ui routes
      {
        path: "ui",
        element: (
       
            <AuthenticationStatus /> 

         
        ),
        children: [
          {
            path: "main",
            element: <MainLayoutContainer />,
            children: [
              { index: true, element: <Navigate to={`${moduleRoutes.dashboard}`} /> },
              { path: `${moduleRoutes.dashboard}/`, children: mainDashboardRoutes },
              { path: `${moduleRoutes.patientCare}/`, children: patientCareRoutes },
              { path: `${moduleRoutes.insurance}/`, children: insuranceRoute },
              { path: `${moduleRoutes.reports}/`, children: reportsRoutes },
              { path: `${moduleRoutes.masters}/`, children: mastersRoutes },
              { path: `${moduleRoutes.settings}/`, children: SettingsRoutes },
              { path: `${moduleRoutes.help}`, children: helpRoute },
              { path: "*", element: <Navigate to={`${base}react/page-not-fount`} /> },
            ],
          },
          { path: "page-not-fount", element: <PageNotFound /> },
          {
            path: `${PageRouterList.doctorQueue}/:doctorId`,
            element: (
              <PrivateRoute>
                <Loader>
                  <DoctorWaitingQueue />
                </Loader>
              </PrivateRoute>
            ),
          },
        ],
      },

      { path: PageRouterList.expired, element: <Loader><TokenExpiredPage /></Loader> },
      { path: PageRouterList.unauthorized, element: <Loader><UnauthorizedAccessPage /></Loader> },
      {
        path: PageRouterList.patientFeedback,
        element: (
          <Loader>
            <PatientFeedbackPage />
          </Loader>
        ),
      },
      {
        path: "api/google/oauth/callback",
        element: <AuthenticationStatus />,
        children: [
          {
            index: true,
            element: (
              <PrivateRoute>
                <Loader>
                  <GoogleOAuthCallback />
                </Loader>
              </PrivateRoute>
            ),
          },
        ],
      },
      { path: "*", element: <PageNotFound /> },
    ],
  },
  { path: "*", element: <PageNotFound /> },
];

export default globalRouteObjectList;
